//
import WhProductModel from '@/models/Warehouse/WhProduct'

/**
 * This class describes a wh product to search.
 *
 * @class      WhProductToSearch (name)
 */
export default class WhProductToSearch extends WhProductModel {

	/**
	 * WhProductToSearch appends & includes
	 */
	static appends = ['stocks']
	static includes = ['wh_item']

	/**
	 * The global warehouse id
	 */
	static global_wh_warehouse_id = 45

	/**
	 * Return the stock from the global warehouse
	 *
	 * @type       {number}
	 */
	get stock_from_global_warehouse() {
		return this
			.stocks
			.reduce(this.reduceStockByWarehouse, 0)
	}

	/**
	 * Reduces the stock by warehouse.
	 *
	 * @param      {number}  total    The total
	 * @param      {object}  current  The current
	 * @return     {number}  The total warehouse stock
	 */
	reduceStockByWarehouse = (total, current) => {
		return total += current.wh_warehouses.reduce(this.reduceStockByWarehouseId, 0)
	}

	/**
	 * Reduces the stock by warehouse identifier.
	 *
	 * @param      {number}  total    The total stock
	 * @param      {object}  current  The current warehouse
	 * @return     {number}  The total warehouse stock
	 */
	reduceStockByWarehouseId = (total, current) => {
		return current.wh_warehouse_id === this.constructor.global_wh_warehouse_id ?
			current.logical_stock
			:
			0
	}
}
